const StartNewSearchEnum = Object.freeze({
  Čeština: 'Zadáním klíčových slov zahájíte nové vyhledávání.',
  Deutsch: 'Geben Sie Stichworte ein, um eine neue Suche zu starten.',
  Français: 'Entrez des mots-clés pour lancer une nouvelle recherche.',
  Slovenčina: 'Zadaním kľúčových slov spustíte nové vyhľadávanie.',
  Español: 'Introduzca las palabras clave para iniciar una nueva búsqueda.',
  English: 'Enter keywords to start a new search.',
})

export default StartNewSearchEnum
